import { render, staticRenderFns } from "./SearchItems.vue?vue&type=template&id=0e31bc23&"
import script from "./SearchItems.vue?vue&type=script&lang=js&"
export * from "./SearchItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports